"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var innerStyles = {
    display: 'block',
    content: '',
    position: 'absolute',
    width: '100%',
    height: '100%',
    transform: 'translateX(-100%)',
};
var config = {
    animation: true,
    animationSpeed: '1.5',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    highLightColor: 'rgba(255, 255, 255, 0.8)',
    secondaryColor: 'rgba(255, 255, 255, 0)',
    innerStyles: innerStyles,
};
exports.default = (0, react_1.createContext)({ config: config });
